/* eslint-disable */
class CustomPrototypes {
  setPrototypes () {
    Date.prototype.atMidnight = function () {
      this.setHours(0, 0, 0, 0)
      return this
    }
    Date.prototype.getLastWeek = function () {
      this.setDate(this.getDate() - 7)
      return this
    }
    Date.prototype.getNextWeek = function () {
      this.setDate(this.getDate() + 7)
      return this
    }
    Date.prototype.getFirstWeekDayDate = function () {
      this.setHours(0, 0, 0, 0)
      return new Date(this.setDate(this.getDate() - this.getDay()))
    }
  }
}

export default CustomPrototypes
